import { useCallback, useEffect, useState } from 'react';
import creationRecordService from '../../services/creationRecordService';

const INITIAL_STATS = {
  total: 0,
  completed: 0,
  processing: 0,
  failed: 0,
};

export default function useCreationRecordData(filter) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(INITIAL_STATS);

  const loadRecords = useCallback(async () => {
    try {
      setLoading(true);
      const response = await creationRecordService.getCreationRecords({
        page: 0,
        size: 100,
        status: filter,
      });
      setRecords(response.records || []);
    } catch (error) {
      console.error('Failed to load creation records:', error);
      setRecords([]);
    } finally {
      setLoading(false);
    }
  }, [filter]);

  const loadStats = useCallback(async () => {
    try {
      const response = await creationRecordService.getCreationStats();
      setStats(response || {});
    } catch (error) {
      console.error('Failed to load statistics:', error);
    }
  }, []);

  useEffect(() => {
    loadRecords();
    loadStats();
  }, [filter, loadRecords, loadStats]);

  return { loading, loadRecords, loadStats, records, stats };
}
